import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'SLE',
  CLIENT_ID: '8',
  COUNTRY: 'sl'
}

export default config
